import AdSlot from "../AdSlot";

export default function HomeTopAd() {
  return (
    <AdSlot
      slot="2729446592"
      className="my-6"
      style={{ minHeight: "100px" }}
    />
  );
}